<template>
  <div class="QuestionExamListModal">
    <el-dialog
      title="选择试卷"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @open="handleOpen"
      @close="handleClose"
    >
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="mini" ref="form">
          <el-form-item label="">
            <el-input
              style="width: 210px"
              v-model="filter.keyword"
              placeholder="试卷名称"
              @keyup.enter.native="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="onSubmit"
              >查找
            </el-button>
            <el-button size="mini" @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <XTable
        ref="multipleTable"
        :api="getExamList"
        :state="examList"
        :columns="columns"
        :loading="examListLoading"
        :tableSize="tableSize"
        :layout="layout"
        :maxHeight="maxHeight"
        @select="handleSelectionChange"
        @select-all="handleAllChange"
      ></XTable>
      <div class="footer">
        <el-button
          size="small"
          style="width: 120px"
          type="primary"
          @click="handleConfirm"
          >确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import XTable from "@/components/XTable/index.vue";

export default {
  name: "QuestionExamListModal",
  components: { XTable },
  data() {
    const columns = [
      {
        type: "selection",
        width: 50,
      },
      {
        prop: "name",
        label: "试卷名称",
      },
      {
        prop: "testQuestionCount",
        label: "试题数",
      },
    ];
    return {
      tableSize: "small",
      layout: " prev, pager, next",
      columns: [...columns],
      maxHeight: 400,
      options: [
        {
          value: null,
          label: "全部",
        },
      ],
      selectExamList: [],
      selectProductSubjects: [],
    };
  },
  watch: {
    examList: {
      handler: function (newValue) {
        if (newValue.data) {
          this.$nextTick(() => {
            this.examList.data.forEach((item) => {
              // 重点： 在当前分页列表中查询与回显数据是否有一致的id，一致则勾选数据回显
              this.productSubjects.forEach((allItem) => {
                if (item.id === allItem.classSubjectId) {
                  this.$refs.multipleTable.$refs.xTable.$refs.appTable.toggleRowSelection(
                    item,
                    true
                  );
                }
              });
            });
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState("teachingCenter", [
      "examList",
      "examListLoading",
      "productSubjects",
    ]),
    visible: {
      get() {
        return this.$store.state.teachingCenter.selectQuestionExamModalVisible;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "selectQuestionExamModalVisible",
          value,
        });
      },
    },
    filter: {
      get() {
        return this.$store.state.teachingCenter.examListFilter;
      },
      set(value) {
        this.$store.commit("teachingCenter/setData", {
          key: "examListFilter",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("teachingCenter", ["setData", "clearFilter"]),
    ...mapActions("teachingCenter", ["getExamList"]),
    // 单行选中状态
    handleSelectionChange(val, row) {
      if (!this.selectExamList.includes(row.id)) {
        // 回显数据里没有本条，把这条加进来(选中)
        this.selectExamList.push(row.id);
        this.selectProductSubjects.push({
          classSubjectId: row.id,
          classSubjectName: row.name,
        });
      } else {
        // 回显数据里有本条，把这条删除(取消选中)
        this.selectExamList.forEach((id, index) => {
          if (id === row.id) {
            this.selectExamList.splice(index, 1);
            this.selectProductSubjects.splice(index, 1);
          }
        });
      }
    },
    handleAllChange(val) {
      if (val.length > 0) {
        val.forEach((item) => {
          if (!this.selectExamList.includes(item.id)) {
            this.selectExamList.push(item.id);
            this.selectProductSubjects.push({
              classSubjectId: item.id,
              classSubjectName: item.name,
            });
          }
        });
      } else {
        this.examList.data.forEach((item) => {
          this.selectExamList.forEach((id, index) => {
            if (id === item.id) {
              this.selectExamList.splice(index, 1);
              this.selectProductSubjects.splice(index, 1);
            }
          });
        });
      }
    },
    handleClose() {
      this.$emit("selectedProductSubjects", this.productSubjects);
      this.$refs.multipleTable.$refs.xTable.$refs.appTable.clearSelection();
    },
    async handleOpen() {
      await this.clearFilter();
      this.selectProductSubjects = JSON.parse(
        JSON.stringify(this.productSubjects)
      );
      this.selectExamList = this.selectProductSubjects.map(
        (item) => item.classSubjectId
      );
      if (this.examList.data) {
        this.$nextTick(() => {
          this.productSubjects.forEach((item1) => {
            const matchingItems = this.examList.data.filter(
              (item2) => item1.classSubjectId === item2.id
            );
            if (matchingItems.length > 0) {
              this.$refs.multipleTable.$refs.xTable.$refs.appTable.toggleRowSelection(
                matchingItems[0],
                true
              );
            }
          });
        });
      }
    },
    async onSubmit() {
      const filters = {
        ...this.filter,
      };
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getExamList({
            ...filters,
            page: 1,
          });
        }
      });
    },
    handleConfirm() {
      this.setData({
        key: "productSubjects",
        value: this.selectProductSubjects,
      });
      this.$emit("selectedProductSubjects", this.productSubjects);
      this.$refs.multipleTable.$refs.xTable.$refs.appTable.clearSelection();
      this.setData({ key: "selectQuestionExamModalVisible", value: false });
    },
    async onReset() {
      await this.clearFilter();
      await this.getExamList({
        page: 1,
      });
    },
    formatData(val) {
      let newVal = [];
      val.map((item, index) => {
        if (item.children) {
          newVal[index] = {
            value: item.id,
            label: item.name,
            children: this.formatData(item.children),
          };
        } else {
          newVal[index] = {
            value: item.id,
            label: item.name,
          };
        }
      });
      return newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.QuestionExamListModal {
  ::v-deep .el-dialog {
    min-width: 880px;
    height: 700px;
  }

  .tableFilter {
    padding-bottom: 30px;

    .el-form-item {
      margin-right: 20px;
    }
  }

  ::v-deep .el-pagination {
    text-align: right;
  }

  .footer {
    margin-top: 30px;
    text-align: center;
  }
}
</style>
